type RawIntegrations = Record<string, any>
type MappedIntegrations = Record<string, boolean>

export function mapIntegrations(raw: RawIntegrations): MappedIntegrations {
  const mapped: MappedIntegrations = {}

  for (const key in raw) {
    const value = raw[key]

    if (Array.isArray(value)) {
      mapped[key] = value.length > 0
      continue
    }

    if (typeof value === 'object' && value !== null) {
      mapped[key] = 'status' in value ? value.status === true : false
      continue
    }

    mapped[key] = false
  }

  return mapped
}
